import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'convertPremiums'
})
export class ConvertPremiumsPipe implements PipeTransform {

  transform(value: any, currentForm: any, productTypes: any): any {
    if (value && currentForm && productTypes) {
      currentForm.patchValue(value);
      const selectedPayments = currentForm.controls.selectedPayments.value
      const newValue = {
        chosenPackageId: value.chosenPackageId,
        recommendedPackage: value.recommendedPackage,
        immovableinsuranceSumRecommended: value.immovableinsuranceSumRecommended,
        movableinsuranceSumRecommended: value.movableinsuranceSumRecommended,
        bottomComfortFour: value.bottomComfortFour,
        bottomComfortOne: value.bottomComfortOne,
        bottomComfortTwo: value.bottomComfortTwo,
        bottomExtraFour: value.bottomExtraFour,
        bottomExtraOne: value.bottomExtraOne,
        bottomExtraTwo: value.bottomExtraTwo,
        bottomMaxFour: value.bottomMaxFour,
        bottomMaxOne: value.bottomMaxOne,
        bottomMaxTwo: value.bottomMaxTwo,
        bottomComfortOneCurr2 : value.bottomComfortOneCurr2,
        bottomExtraOneCurr2 :  value.bottomExtraOneCurr2,
        bottomMaxOneCurr2 :  value.bottomMaxOneCurr2,
        bottomComfortTwoCurr2 : value.bottomComfortTwoCurr2,
        bottomExtraTwoCurr2 : value.bottomExtraTwoCurr2,
        bottomMaxTwoCurr2 : value.bottomMaxTwoCurr2,
        bottomComfortFourCurr2 :value.bottomComfortFourCurr2,
        bottomExtraFourCurr2 : value.bottomExtraFourCurr2,
        bottomMaxFourCurr2 : value.bottomMaxFourCurr2,
        movableinsuranceSumCurr2: value.movableinsuranceSumCurr2,
        immovableinsuranceSumCurr2: value.immovableinsuranceSumCurr2,
        paymentPlans: [
          {
            packageName: productTypes.find(item => item.value === '1').label,
            packageId: '1',
            totalNetPremium: (currentForm.controls.selectedPayments.value == 2 || currentForm.controls.selectedPayments.value == 4) ? value.n_1NSP_Premium : value.topComfort,
            bottomNetPremium: value.n_1NSP_Premium,
            bottomNetPremiumEuro: value.n_1NSP_PremiumCurr2,
            totalTax: 0,
            packageRisks: {
              packageId: '1',
              packageName: 'Comfort',
              discount1: value.discount1,
              discount2: value.discount2,
              discount4: value.discount4,
            },
            packageBaseRisks: {
              risks: 'comfort'
            }
          },
          {
            packageName: productTypes.find(item => item.value === '2').label,
            packageId: '2',
            // totalNetPremium: value.topExtra,
            totalNetPremium: (currentForm.controls.selectedPayments.value == 2 || currentForm.controls.selectedPayments.value == 4) ? value.n_2NSP_Premium : value.topExtra,
            bottomNetPremium: value.n_2NSP_Premium,
            bottomNetPremiumEuro: value.n_2NSP_PremiumCurr2,
            totalTax: 0,
            packageRisks: {
              packageId: '2',
              packageName: 'Extra',
              discount1: value.discount1,
              discount2: value.discount2,
              discount4: value.discount4,
            },
            packageBaseRisks: {
              risks: 'extra'
            }
          },
          {
            packageName: productTypes.find(item => item.value === '3').label,
            packageId: '3',
            // totalNetPremium: value.topMax,
            totalNetPremium: (currentForm.controls.selectedPayments.value == 2 || currentForm.controls.selectedPayments.value == 4) ? value.n_3NSP_Premium : value.topMax,
            bottomNetPremium: value.n_3NSP_Premium,
            bottomNetPremiumEuro: value.n_3NSP_PremiumCurr2,
            totalTax: 0,
            packageRisks: {
              packageId: '3',
              packageName: 'Max',
              discount1: value.discount1,
              discount2: value.discount2,
              discount4: value.discount4,
            },
            packageBaseRisks: {
              risks: 'max'
            }
          },
        ]
      }
      return newValue
    }
    return value;
  }

}
